/* Clementa — "Busy Moms" landing page behavior. */
(function () {
  if (window.__lpBmInit) return;
  window.__lpBmInit = true;

  var ready = function (fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); };

  function pad(n) { return String(n).padStart(2, '0'); }
  function fmt(total) { if (total < 0) total = 0; return pad(Math.floor(total / 3600)) + ':' + pad(Math.floor((total % 3600) / 60)) + ':' + pad(total % 60); }
  function secsUntilMidnight() { var now = new Date(); var mid = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0); return Math.floor((mid - now) / 1000); }
  function initCountdowns() {
    document.querySelectorAll('[data-lp-countdown],[data-lp-countdown-midnight]').forEach(function (el) {
      if (el.__lpTimer) return; el.__lpTimer = true;
      var midnight = el.hasAttribute('data-lp-countdown-midnight');
      var hours = parseInt(el.getAttribute('data-lp-countdown'), 10);
      if (isNaN(hours) || hours <= 0) hours = 24;
      var start = hours * 3600 - 1;
      var total = midnight ? secsUntilMidnight() : start;
      function tick() { if (midnight) total = secsUntilMidnight(); el.textContent = fmt(total); if (!midnight) total = total > 0 ? total - 1 : start; }
      tick(); setInterval(tick, 1000);
    });
  }

  function initStickyBar() {
    var bars = document.querySelectorAll('[data-lp-sticky]');
    if (!bars.length) return;
    var anchor = document.querySelector('[data-lp-sticky-anchor]') || document.querySelector('.lp-bm-hero');
    if (!anchor || !('IntersectionObserver' in window)) { bars.forEach(function (b) { b.classList.add('lp-bm-show'); }); return; }
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (e) { bars.forEach(function (b) { b.classList.toggle('lp-bm-show', !e.isIntersecting); }); }); }, { threshold: 0 });
    io.observe(anchor);
  }

  function initReveal() {
    var els = document.querySelectorAll('.lp-bm-reveal:not(.lp-bm-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('lp-bm-in'); }); return; }
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('lp-bm-in'); io.unobserve(e.target); } }); }, { threshold: 0.16 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initQuantity() {
    document.querySelectorAll('.lp-bm-qty').forEach(function (wrap) {
      if (wrap.__lpQty) return; wrap.__lpQty = true;
      var input = wrap.querySelector('input'); if (!input) return;
      wrap.querySelectorAll('button[data-lp-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-lp-step'), 10);
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var val = parseInt(input.value, 10) || min;
          val = Math.max(min, val + step); input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function initBogo() {
    document.querySelectorAll('[data-lp-bogo]').forEach(function (wrap) {
      if (wrap.__lpBogo) return; wrap.__lpBogo = true;
      var qtyInput = wrap.querySelector('[data-lp-bogo-qty]');
      var radios = wrap.querySelectorAll('input[type="radio"]');
      var scope = wrap.closest('.lp-bm-card__body') || document;
      var priceBox = scope.querySelector('[data-lp-price]');
      var caption = scope.querySelector('[data-lp-price-caption]');
      function update() {
        var checked = wrap.querySelector('input[type="radio"]:checked');
        var val = checked ? checked.value : '1';
        if (qtyInput) { qtyInput.value = val; qtyInput.dispatchEvent(new Event('change', { bubbles: true })); }
        wrap.querySelectorAll('[data-lp-bogo-opt]').forEach(function (opt) {
          opt.classList.toggle('is-selected', opt.getAttribute('data-lp-bogo-opt') === val);
        });
        if (priceBox) {
          var amount = priceBox.querySelector('[data-lp-price-amount]');
          var badge = priceBox.querySelector('[data-lp-price-badge]');
          var badgeText = priceBox.querySelector('[data-lp-price-badge-text]');
          var newPrice = priceBox.getAttribute('data-price-' + val);
          var newBadge = priceBox.getAttribute('data-badge-' + val);
          if (amount && newPrice) amount.textContent = newPrice;
          if (badge) badge.style.display = newBadge ? '' : 'none';
          if (badgeText) badgeText.textContent = newBadge || '';
        }
        if (caption) {
          var newCaption = caption.getAttribute('data-caption-' + val);
          caption.style.display = newCaption ? '' : 'none';
          caption.textContent = newCaption || '';
        }
      }
      radios.forEach(function (r) { r.addEventListener('change', update); });
      update();
    });
  }

  function initVariants() {
    document.querySelectorAll('[data-lp-buybox]').forEach(function (box) {
      var dataEl = box.querySelector('[data-lp-variant-json]');
      var idInput = box.querySelector('.lp-bm-variant-id');
      if (!dataEl || !idInput) return;
      var variants; try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      function selectedOptions() { var opts = []; box.querySelectorAll('[data-lp-option-index]').forEach(function (group) { var checked = group.querySelector('input:checked'); if (checked) opts[parseInt(group.getAttribute('data-lp-option-index'), 10)] = checked.value; }); return opts; }
      function update() {
        var opts = selectedOptions();
        var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
        if (!match) return;
        idInput.value = match.id;
        var nowEl = box.querySelector('.lp-bm-now'); if (nowEl && match.price_money) nowEl.textContent = match.price_money;
        var btn = box.querySelector('.lp-bm-atc');
        if (btn) { var t = btn.querySelector('.lp-bm-atc__text'); if (match.available) { btn.removeAttribute('disabled'); if (t && btn.dataset.lpLabel) t.textContent = btn.dataset.lpLabel; } else { btn.setAttribute('disabled', 'disabled'); if (t && btn.dataset.lpSoldout) t.textContent = btn.dataset.lpSoldout; } }
      }
      box.querySelectorAll('[data-lp-option-index] input').forEach(function (i) { i.addEventListener('change', update); });
    });
  }

  function cartUrl(path) { var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; if (root.charAt(root.length - 1) !== '/') root += '/'; return root + path; }
  function updateCartBubble(data) {
    try { var html = data && data.sections && data.sections['cart-icon-bubble']; if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.shopify-section') ? doc.querySelector('.shopify-section').innerHTML : doc.body.innerHTML;
      ['cart-icon-bubble', 'CartCount'].forEach(function (id) { var t = document.getElementById(id); if (t && fresh) t.innerHTML = fresh; });
    } catch (e) {}
  }
  function openCartDrawer(data) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') { try { drawer.classList.remove('is-empty'); drawer.renderContents(data); if (typeof drawer.open === 'function') drawer.open(); return true; } catch (e) {} }
    var note = document.querySelector('cart-notification');
    if (note && typeof note.renderContents === 'function') { try { note.renderContents(data); return true; } catch (e) {} }
    return false;
  }

  function initAddToCart() {
    document.querySelectorAll('form.lp-bm-form').forEach(function (form) {
      if (form.__lpAtc) return; form.__lpAtc = true;
      form.addEventListener('submit', function (ev) {
        if (!window.fetch) return; ev.preventDefault();
        var btn = form.querySelector('.lp-bm-atc');
        var errEl = form.querySelector('.lp-bm-form__err'); if (errEl) errEl.textContent = '';
        var original = btn ? btn.innerHTML : ''; if (btn) btn.setAttribute('disabled', 'disabled');
        var after = form.getAttribute('data-lp-after') || 'drawer';
        var fd = new FormData(form);
        if (after !== 'cart') { fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', window.location.pathname); }
        fetch(cartUrl('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) { if (errEl) errEl.textContent = res.data.description || res.data.message || 'Nie udało się dodać do koszyka.'; if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = original; } return; }
            if (btn) { btn.classList.add('lp-bm-btn--added'); var txt = btn.querySelector('.lp-bm-atc__text'); var done = btn.getAttribute('data-lp-added') || 'Dodano ✓'; if (txt) txt.textContent = done; else btn.textContent = done; setTimeout(function () { btn.classList.remove('lp-bm-btn--added'); btn.removeAttribute('disabled'); btn.innerHTML = original; }, 2500); }
            if (after === 'cart') { window.location.href = cartUrl('cart'); return; }
            updateCartBubble(res.data);
            if (after === 'stay') return;
            if (!openCartDrawer(res.data)) { window.location.href = cartUrl('cart'); }
          })
          .catch(function () { if (btn) { btn.removeAttribute('disabled'); btn.innerHTML = original; } form.submit(); });
      });
    });
  }

  function initScrollButtons() {
    document.querySelectorAll('[data-lp-scroll-to]').forEach(function (el) {
      if (el.__lpScroll) return; el.__lpScroll = true;
      el.addEventListener('click', function (ev) { var sel = el.getAttribute('data-lp-scroll-to'); var target = sel ? document.querySelector(sel) : null; if (target) { ev.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); } });
    });
  }

  function initFaq() {
    document.querySelectorAll('.lp-bm-faq__q').forEach(function (q) {
      if (q.__lpFaq) return; q.__lpFaq = true;
      q.addEventListener('click', function () { var item = q.closest('.lp-bm-faq__item'); var ans = item.querySelector('.lp-bm-faq__a'); var open = item.classList.toggle('lp-bm-open'); ans.style.maxHeight = open ? ans.scrollHeight + 'px' : '0px'; q.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    });
  }

  /* Product gallery: swipeable main image + arrows + thumbnails (Shopify-style) */
  function initGallery() {
    document.querySelectorAll('[data-lp-gallery]').forEach(function (g) {
      if (g.__lpG) return; g.__lpG = true;
      var track = g.querySelector('[data-lp-track]');
      if (!track) return;
      var slides = track.querySelectorAll('.lp-bm-gallery__slide');
      var thumbs = g.querySelectorAll('[data-lp-thumb]');
      var prev = g.querySelector('[data-lp-prev]');
      var next = g.querySelector('[data-lp-next]');
      function cur() { return Math.round(track.scrollLeft / track.clientWidth); }
      function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(cur() - 1); });
      if (next) next.addEventListener('click', function () { go(cur() + 1); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var idx = cur();
          thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
        });
      });
    });
  }

  function runAll() {
    initCountdowns(); initStickyBar(); initReveal(); initQuantity(); initBogo();
    initVariants(); initAddToCart(); initScrollButtons(); initFaq(); initGallery();
  }

  ready(runAll);
  document.addEventListener('shopify:section:load', runAll);
})();
